import React from 'react';

import './HomeRouteNavigationButton.css'

export default function HomeRouteNavigation({ featuredProjects, featuredProjectsOpened, nonFeaturedProjects, nonFeaturedProjectsOpened, photoGallery, photoGalleryOpened }) {



    const renderFeaturedProjects = () => {
        const projectHeaderButtonPTagText = document.getElementById('HomeRoute-NavigationButton-PTag-Text')
        if (featuredProjects === true) {
            projectHeaderButtonPTagText.textContent = 'Photo-Gallery'
            featuredProjectsOpened(!featuredProjects)
            nonFeaturedProjectsOpened(!nonFeaturedProjects)
        }
        if (nonFeaturedProjects === true) {
            projectHeaderButtonPTagText.textContent = 'Featured'
            nonFeaturedProjectsOpened(!nonFeaturedProjects)
            photoGalleryOpened(!photoGallery)
        }
        if (photoGallery === true) {
            projectHeaderButtonPTagText.textContent = 'Non-Featured'
            photoGalleryOpened(!photoGallery)
            featuredProjectsOpened(!featuredProjects)
        }
    }

    return (
            <button onClick={renderFeaturedProjects} id="HomeRoute-NavigationButton" className='HomeRoute-NavigationButton-Color HomeRoute-NavigationButton-Animation-Open HomeRoute-NavigationButton-Shape HomeRoute-NavigationButton-Position HomeRoute-NavigationButton-Dimensions'><p id="HomeRoute-NavigationButton-PTag-Text" className='HomeRoute-NavigationButton-PTag-Text'>Non-Featured</p></button>
    )

}